<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>REPORTE ANÁLISIS DE MUESTRAS DE TICKET</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione un Rango de Fechas</label>
                            <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                        </div>
                    </div>

                    <div class="col">
                        <!-- <select name="" id="" v-model="mps_id" class="form-control">
                            <option :value="m.id" v-for="m in materias_primas" :key="m.id">{{m.nombre}}</option>
                        </select> -->
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Materia Prima</label>
                            <v-select class="" :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos">Cargar</button>
                        <button v-show="url_excel" class="btn btn-success btn-icon" @click="exportar_excel">Excel</button>
                    </div>
                </div>


                <div class="row mt-1">
                    <div class="col" v-for="(item,idx) in datos" :key="idx">
                        <h2>TABLA TICKETS {{item.mp}}</h2>
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered" >
                                    <thead class="">
                                        <tr class="">
                                            <th class="fixed thead-orange text-center"></th>
                                            <th class="fixed thead-orange text-center "></th>
                                            
                                            <th class="fixed thead-orange text-center" :colspan="s.lab_item_parametros.length" v-for="(s,i) in item.secciones" :key="i">{{s.nombre}}</th>
                                        </tr>
                                        <tr>
                                            <th class="fixed-2 thead-orange borde-negro">Ticket</th>
                                            <th class="fixed-2 thead-orange borde-negro">Guia</th>
                                            <th class="fixed-2 thead-orange text-center borde-negro" v-for="(p,inx) in parametros(item.secciones)" :key="inx">
                                                    {{p.parametro_texto}}
                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
                <!-- <pre>{{fechas}}</pre> -->
                <pre>{{total_resultado}}</pre>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        todos:true,
        columnas:[
            {show:true,label:'Fecha Recepción',tipo:'string',path:'fecha_recepcion'},
            {show:true,label:'Hora Recepción',tipo:'string',path:'hora_recepcion'},
            {show:true,label:'Fecha/Hora Salida Origen',tipo:'string',path:'fecha_hora_origen'},
            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Bins',tipo:'string',path:'cantidad_bins'},
            {show:true,label:'N° D.Tributario',tipo:'string',path:'numero_guia'},
            {show:true,label:'Folio PCC',tipo:'string',path:'folio_guia'},
            {show:true,label:'Neto Informado (Ton)',tipo:'string',path:'peso_informado_guia_ton'},
            {show:true,label:'Codigo Agente Origen',tipo:'string',path:'siep_sucursal'},
            {show:true,label:'Nombre Agente Origen',tipo:'string',path:'sucursal'},
            {show:true,label:'Fecha GD',tipo:'string',path:'fecha_guia'},
            {show:true,label:'Codigo Proveedor',tipo:'string',path:'siep_empresa'},
            {show:true,label:'Nombre Proveedor',tipo:'string',path:'empresa'},
            {show:true,label:'Neto Corregido (Ton)',tipo:'string',path:'peso_real_guia_ton'},
            {show:true,label:'% Guía',tipo:'string',path:'porcentaje_guia'},
            {show:true,label:'Peso Por Guía (Ton)',tipo:'string',path:'peso_real_guia_ton'},
            {show:true,label:'CR/SR',tipo:'string',path:'tiene_restriccion'},
            {show:true,label:'Restriccion',tipo:'string',path:'restricciones'},
            {show:true,label:'Tipo MMPP',tipo:'string',path:'materia_prima'},
            {show:true,label:'Especie',tipo:'string',path:'especie'},
            {show:true,label:'Horas Traslado MMPP',tipo:'string',path:'horas_traslado'},
            {show:true,label:'Menos 24 Hrs de traslado o refrigerado',tipo:'string',path:'cumple_24_hrs'},
            {show:true,label:'Peso Neto (Ton)',tipo:'string',path:'peso_neto_guia_ton'},
            {show:true,label:'Codigo Centro Origen',tipo:'string',path:'codigos_centros'},
            {show:true,label:'Nombre Centro Origen',tipo:'string',path:'nombre_centros'},
            {show:true,label:'Jaula Origen',tipo:'string',path:'jaulas_centros'},


            

        ],

        proveedores:[],
        datos:[],
        mps_id:[],
        destinos_id:[],
        empresas_id:[],
        especies_id:[],
        materias_primas:[],
        especies:[],
        mps_seleccionadas:[],
        destinos:[],
        total_resultado:null,
        url_excel:null,
        agrupar_empresa:true,
        agrupar_sucursal:true
    }),
    mounted(){
        this.cargar_materias_primas();
    },
    methods:{
        async cargar_materias_primas(){
          await this.axios.get(`${this.api}/mps_tipo?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.materias_primas = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_datos();
        },

        async cargar_datos(){
            if(this.fechas[0] != null && this.fechas[0] != undefined){
                let body = {
                    desde:this.fechas[0],
                    hasta:this.fechas[1],
                    mps_id:this.mps_id,
                };
                await this.axios.post(`${this.api}/reportes/analisis_tickets`,body,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.datos = res.data.data;
                    this.total_resultado = res.data.data.total;
                    this.url_excel = res.data.data.url_excel;
                }).catch(e=>{
                    //console.log(e);
                });
            }
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
            /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        abrirPdf(d){
            window.open(`${this.api_public}/guias/${d.url_guia}`, '_blank');
        },

        abrirDeclaracion(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`, '_blank');
        },

        abrirCam(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.cam}`, '_blank');
        },

        parametros(secciones){
            let params = [];
            secciones.forEach(s => {
                    params = params.concat(s.lab_item_parametros);
            });
            return params;
        }
    },
    computed:{

        ...mapState(['api','api_public','cabeceras_json','token']),
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; top: 0; z-index: 100;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>